/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useActivation } from '@context/MobileOne';
import { ButtonPrimary } from '@core/ButtonPrimary';
import { Link } from '@core/Link';
import { PopupText } from '@core/PopupText';
import { appButtonType, appIconsPath, appLinkSize, appLinkStyle } from '@utils/globalConstant';
import { tA11y } from '@utils/a11y/a11yHelpers';

export function CancelRegistrationPopup() {
  // Contexts
  const {showActivationCancelModal, setShowActivationCancelModal, handleCancelButtonClick} = useActivation();
  
  return (
    <PopupText
      isOpen={showActivationCancelModal}
      title="ek_reg_actvn_cncl_hdl1"
      desc="ek_reg_actvn_cncl_txt1"
      onClose={() => setShowActivationCancelModal(false)}
      footerChildren={
        <div className="m-0">
          <div className="row">
            <div className="col-lg-5 col-11 px-0 mx-auto">
              <ButtonPrimary
                buttonClass="mb-24"
                id={'cancel-confirmation-button'}
                buttonType={appButtonType.SECONDARY}
                buttonContent={tA11y('ek_reg_actvn_cncl_btn1')}
                label="ek_reg_actvn_cncl_btn1"
                onClick={handleCancelButtonClick}
              />
            </div>
            <div className="col-12">
              <Link
                label="ek_reg_actvn_cncl_lnk1"
                iconRight={appIconsPath.ARROW_RIGHT_SMALL}
                linkStyle={appLinkStyle.SECONDARY}
                linkSize={appLinkSize.DEFAULT}
                onClick={() => setShowActivationCancelModal(false)}
              />
            </div>
          </div>
        </div>
      }
    />
  );
}

export default CancelRegistrationPopup;